import styled from "styled-components";

export const DeleteLink = styled.a`
    && {
        color: var(--error-color);

        &:hover {
            color: var(--error-color-hover);
        }
    }
`;
